export default {
  methods: {
    getLocale() {
      return ["en", "zh-Hant-HK"];
    },

    getFilteredTranslations(insuranceCompanyTranslationsData) {
      const returnData = insuranceCompanyTranslationsData.filter((translation) =>
        {
          return this.getLocale().includes(translation.attributes.locale);
        }
      );

      const currentLocale = this.$normalizeLocale(this.$i18n.locale);
      const index  = returnData.findIndex(translation => translation.attributes.locale === currentLocale);
      if (index !== -1)
      {
        const [currentTranslation] = returnData.splice(index, 1);
        returnData.unshift(currentTranslation);
      }

      return returnData;
    },

    getCheckoutTranslations(translationData)  {
      const currentLocale = this.$normalizeLocale(this.$i18n.locale);
      return translationData.filter((item) => {
        return item.locale === currentLocale;
      });
    }
  }
}
